import { Navigate } from "~/router";

function SignUp() {
  return <Navigate to="/signin" />;
}

export default SignUp;
